class MenuItem {
  link: string;

  label: string;

  subLabel?: string | null;

  section?: string | null;

  isRoot?: boolean;

  isDisabled?: boolean;

  constructor(
    link: string,
    label: string,
    subLabel: string | null = null,
    section: string | null = null,
    isRoot = false,
    isDisabled = false
  ) {
    this.link = link;
    this.label = label;
    this.subLabel = subLabel;
    this.section = section;
    this.isRoot = isRoot;
    this.isDisabled = isDisabled;
  }
}

export default MenuItem;
